import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";

import "./css/layout/Layout.css";
import store from "./store/store";
import user from "./store/actions/user";

import Loading from "./layout/Loading";
import Header from "./layout/Header";
import MobileMenu from "./layout/MobileMenu";
import Home from "./route/Home";
import About from "./route/About";
import Product from "./route/Product";
import Brand from "./route/Brand";
import Contact from "./route/Contact";
import Contact_Succeed from "./route/Contact_Succeed";
import Footer from "./layout/Footer";


function App() {
    const [language, setLanguage] = useState()

    function changeLanguage(lang) {
        setLanguage(lang)
        localStorage.setItem("language", lang)
        store.dispatch(user.updateLanguage(lang))

        let headerNav = document.getElementById("headerNav")
        let meta = document.head.querySelector('meta[name="description"]')
        if (lang === "ko") {
            if (headerNav) {
                for (let i = 0; i < headerNav.children.length; i++) {
                    headerNav.children[i].style.fontFamily = "'Noto Serif', serif"
                    headerNav.children[i].style.fontSize = "18px"
                }
            }
            if (meta) {
                meta.content = `유니텍오토는 1994년 설립된 국내 최대 상용차 부품 공급업체입니다. Scania, Volvo, MAN, Mercedes Benz 등 150개 이상 제조업체의 12,000개 이상 자동차 부품을 공급합니다.`
            }
            document.title = `유니텍오토 | 국내 최대 상용차 부품 공급업체`
        } else {
            if (headerNav) {
                for (let i = 0; i < headerNav.children.length; i++) {
                    headerNav.children[i].style.fontFamily = "Noto Serif, serif"
                    headerNav.children[i].style.fontSize = "16px"
                }
            }
            if (meta) {
                meta.content = `Unitech Auto is Korea's largest commercial vehicle parts supplier since 1994. Over 12,000 auto spare parts from 150+ manufacturers including Scania, Volvo, MAN, Mercedes Benz.`
            }
            document.title = `Unitech Auto | Korea's Largest Commercial Vehicle Parts Supplier`
        }
    }

    useEffect(() => {

    }, [language])

    return (
        <Provider store={store}>
            <div className="App">
                <Router>
                    <Loading />
                    <Header changeLanguage={changeLanguage} />
                    <MobileMenu />
                    <Switch>
                        <Route exact path={"/"} component={Home} />
                        <Route path={"/about"} component={About} />
                        <Route path={"/contact"} component={Contact} />
                        <Route path={"/product"} component={Product} />
                        <Route path={"/brand"} component={Brand} />
                        <Route path={"/Contact_Succeed"} component={Contact_Succeed} />
                    </Switch>
                    <Footer changeLanguage={changeLanguage} />
                </Router>
            </div>
        </Provider>
    );
}

export default App;
